import { render, staticRenderFns } from "./QuestionBankCohortsList.vue?vue&type=template&id=4a928f1d&"
import script from "./QuestionBankCohortsList.vue?vue&type=script&lang=js&"
export * from "./QuestionBankCohortsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports